module.exports = __webpack_public_path__ + "img/keyboard-arrow-bottom-right.7c354ff4.svg";